import { useDetailApi } from "../../../swr/useApi";
import type { ProductDealTypeDto } from "../../../api";
import { productDealTypesService } from "../../api_client";

export function useProductDealType(id?: number | null) {
    return useDetailApi<ProductDealTypeDto>({
        key: `product-deal-type-${id ?? "none"}`,
        serviceMethod: async () =>
            await productDealTypesService.getProductDealTypeById(id as number),
        options: {
            isPaused: () => !id,
        },
    });
}
